import { useEffect, useState } from "react";
import { isDev } from "../../../base/index.js";
import { createPubSub } from "../../../javascript-utils/pubSub/index.js";
import { useFormDevtoolsState, useFormDevtoolsStateApi } from "./formDevtoolsContext.js";
const observer = createPubSub();
const store = /* @__PURE__ */ new Map();
function registerFormToDevtools(form) {
  const uid = form.api.getFormId();
  if (store.has(uid)) {
    if (isDev()) {
      console.warn(
        `[Tidal Form Devtools] A form with id ${uid} already exists. A Form name must be unique. This form instance won't be visible through the devtools.`
      );
    }
    return () => {
    };
  }
  store.set(uid, form);
  observer.notify({ type: "update", action: "add", uid, instance: form });
  return () => {
    store.delete(uid);
    observer.notify({ type: "update", action: "remove", uid, instance: form });
  };
}
function useTidalFormDevtoolsList() {
  const [formList, setFormList] = useState(() => Array.from(store.keys()));
  useEffect(() => {
    const unsubscribe = observer.listen((action) => {
      setFormList(Array.from(store.keys()));
    });
    setFormList(Array.from(store.keys()));
    return () => {
      unsubscribe();
    };
  }, []);
  return formList;
}
function useTidalFormDevtoolsInstance(formId) {
  const [, forceRerender] = useState(0);
  useEffect(() => {
    const unsubscribe = observer.listen((action) => {
      forceRerender((p) => p + 1);
    });
    forceRerender((p) => p + 1);
    return () => {
      unsubscribe();
    };
  }, []);
  return store.get(formId);
}
function useShowDevtools() {
  const { open } = useFormDevtoolsState();
  const { setOpen } = useFormDevtoolsStateApi();
  return [open, setOpen];
}
export {
  registerFormToDevtools,
  useShowDevtools,
  useTidalFormDevtoolsInstance,
  useTidalFormDevtoolsList
};
//# sourceMappingURL=formDevtools.js.map
